<template>
  <div class="cv-show-wrapper" :class="[{'zero-show': !score}, {'zero-show-hide-tool-tip': !score && !pcEditorState}, {'cv-show-wrapper-hide-tool-tip': !pcEditorState}]" v-show="loadingPageOver">
    <w-navbar :icon="'iconchevron-left'" :cvShow="true" :nav_title="cv.basic_info && cv.basic_info.cv_name"
              @mobileLeftBtn="leftBtnClick" @mobileRightBtn="toPreview"/>
    <w-loading v-if="loadingShow"/>
    <div class="cv-show" v-else>
      <div class="flex-between top-tool-tip" v-if="pcEditorState">
        <div class="flex-start">
          <i class="iconfont iconx" @click="pcEditorState = false" />
          <span>PC端编辑简历效率更高哦~</span>
        </div>
        <router-link class="flex-start" to="/welcome/use_pc_page">
          <span class="to-pc">去PC端</span>
        </router-link>
      </div>
      <div class="flex-between rate-header" :class="{'rate-header-hide-tool-tip': !pcEditorState}" v-if="score">
        <p class="rate headline">简历专业评分：{{score}}分</p>
        <div class="white-button header-btn flex-center" @click="checkCount">{{ checkText }}</div>
      </div>
      <div class="rate-container" v-if="score">
        <progress-bar :percent="score"/>
        <div class="info" v-html="scoreDesc"></div>
      </div>
      <mobile-cv @addAvatar="addAvatar" @changeUpload="changeUpload" @deleteConfirm="deleteConfirm"/>
      <!-- <div id="manage-btn" class="module-manage flex-center" @click="toModuleManage">模块管理</div> -->
      <editor-suggest v-if="score" :suggest-state="suggestState" :member="userData.is_membership"
                      :check-over="checkOver"
                      :not-member-again-check="notMemberAgainCheck" @handleClose="suggestState = false"
                      @changeCv="changeCv"/>
      <editor-more :more-state="moreState" @refresh="refresh" @handleClose="moreState = false" @changeCv="changeCv"/>
      <name-privacy :setting-show="settingShow" :settingType="settingType" :cv-data="cv.basic_info"
                    @handleClose="settingShow = false"
                    @refresh="refresh"/>
      <w-popup-show :state="avatarState" @handleClose="handleClose">
        <div slot="content" class="avatar-content">
          <div class="operation">
            <div class="operation-item" @click="changeUpload('avatar')">
<!--              <span class="iconfont iconbianji"/>-->
              <span>重新上传</span>
            </div>
            <div class="operation-item" @click="deleteConfirm('avatar')">
<!--              <span class="iconfont iconshanchujianli"/>-->
              <span>删除</span>
            </div>
          </div>
          <div class="avatar-bottom flex-center" @click="handleClose">取消</div>
        </div>
      </w-popup-show>
      <upload-avatar :upload-show="uploadShowAvatar" @uploadSuccess="changeAvatar" @handleClose="handleClose"
                     uploadType="avatar"/>
      <upload-school-logo :upload-show="uploadShowLogo" @addSchoolLogo="addSchoolLogo" @handleClose="handleClose"
                          uploadType="logo"/>
    </div>
    <over-match-cv :state="matchShow" @handleClose="matchShow = false"/>
		<div class="comment-total-container" @click="toCvComment" v-if="commentTotal">
			<i class="iconfont iconpinglun2" />
			<span>({{commentTotal}}条)</span>
		</div>
    <nps :isShow="npsFlag && isShowNPSModuleNum" @showNps="showNps" :token="token"/>
    <w-scale @handleClose="closeCvOnline" :scaleShow="cvOnlineFlag" :top="34">
      <div class="cv-online-popup" slot="content">
        <div class="title-container">
          <span class="title">简历优先推荐中</span>
          <i class="iconfont iconx" @click="closeCvOnline" />
        </div>
        <div class="content-container">
          <div v-for="(item, index) in cvOnlineText" :key="index" class="item" :class="{'active': item.active}">
            <div class="point" />
            <div class="text">{{ item.text }}</div>
          </div>
        </div>
        <div class="btn-container">
          <div class="btn cancel-btn" @click="$router.push('/account/privacy')">设置</div>
          <div class="btn confirm-btn" @click="changePrivacy">立即开启</div>
        </div>
      </div>
    </w-scale>
    <editorBottombar @editorBottomClick="editorBottomClick"></editorBottombar>
  </div>
</template>

<script>
	import WLoading from '@/components/global/w-loading'
	import WNavbar from '@/components/global/w-navbar'
	import WPopupShow from '@/components/global/w-popup-show'
  import WScale from '@/components/global/w-scale'
	import progressBar from '@/components/cv/progress-bar'
	import editorBar from './editor-bar'
	import editorSuggest from './editor-suggest'
	import editorMore from './editor-more'
  import editorBottombar from './editor-bottombar'
	import mobileCv from './mobile-cv'
	import namePrivacy from '../cv-components/name-privacy'
	import overMatchCv from '../cv-components/overmatch-cv'
	import upload from '../cv-components/upload'
	import { mapState, mapActions, mapMutations } from 'vuex'
	import { cvMixin } from '../../assets/js/mixin/cv'
	import { componentsMixin } from '../../assets/js/mixin/components'
	import { loginMixin, envMixin } from '../../assets/js/mixin/global'
	import { userMixin } from '../../assets/js/mixin/user'
	import { scoreDescription } from '../../assets/json/score-description'
  import nps from '../../components/nps/index'
	let moment = require('moment')
	export default {
		mixins: [ envMixin, cvMixin, componentsMixin, userMixin, loginMixin ],
		data () {
			return {
        token: this.$route.params.token,
				loadingShow: true,
				rightBtnHtml: '导出',
				suggestState: false,
				moreState: false,
				settingShow: false,
				changeNameState: false,
				settingType: '',
				sectionInfo: {},
				checkOver: false,
				matchShow: false,
				top: 0,
				text: '智能检查',
				uploadShowAvatar: false,
				avatarState: false,
				uploadShowLogo: false,
				fromName: '', // 从哪个页面进入的
				scrollOptions: {
					bounce: {
						bottom: false,
					}
				},
        pcEditorState: true, // 引导pc编辑
				commentTotal: 0, //当前简历批注的条数
				encodedToken: 'EvN_P2hV',
        cvOnlineFlag: false,  // 在线简历同步弹窗
        cvOnlineText: [
          {
            active: false,
            text: "已达优秀简历标准，正优先推荐至 HR"
          },
          {
            active: false,
            text: "可在【设置】选择屏蔽公司/关闭推荐"
          },
          {
            active: true,
            text: "开启直接联系：允许HR主动与你交换联系方式，不再错过重要机会"
          },
        ],   // 在线简历弹窗内容文案
        privacy: {
          recommend_for_hr: false,   // 对企业HR推荐
          recommend_for_classmate: false, // 对校友/前同事推荐
          recommend_for_internal: false,   // 对有内推资源者推荐
          increase_exposure: false, // 加强曝光
          contact_directly: false,   // 	直接联系
          contact_insite: false   // 站内联系
        },   // 开关状态
			}
		},
		beforeRouteUpdate (to, from, next) {
			this.token = to.params.token
			this._getCvDetail()
			next()
		},
    // created() {
    //   this.getPersonPrivacy()
    // },
    async mounted () {
			// 各种小程序根据jwt&&jwt_timestamp 自动登录
      await this.miniprogramAutoLogin();
			this.initCommentData()
			this.initStoreData()
			this.initOnlineState()
			this.getUserData()
			await this._getCvDetail()
			this.initScrollPoint()
			this.getEncodedToken()
			// this.getCvScore()
			// this._createProfile()
		},
		components: {
			WLoading,
			WNavbar,
			progressBar,
			mobileCv,
			editorBar,
      editorBottombar,
			editorSuggest,
			editorMore,
			namePrivacy,
			overMatchCv,
			WPopupShow,
			uploadAvatar: upload,
			uploadSchoolLogo: upload,
      nps,
      WScale
		},
		watch: {
			refreshEditor (val) {
				if (val) {
					this._dealCvData()
          this.changeRefreshEditor(false)
        }
      }
    },
		computed: {
			...mapState('cv', [ 'score', 'cv', 'cvSort', 'profiles', 'moduleData', 'suggestions', 'refreshEditor', 'syncSuccess','npsFlag' ]),
			...mapState('cvIndex', [ 'softDeleteCount' ]),
      ...mapState('cvExperience', [ 'experienceEnter' ]),
			// 简历的类型
			cvKind () {
				return this.cv.basic_info.kind
			},
			// 判断分数不为0，没有profiles
			notProfile () {
				// return this.cv.basic_info.score > 0 && Object.keys(this.profiles)
				return 0
			},
			//  非会员二次检查
			notMemberAgainCheck () {
				let time = moment().format('YYYY-MM-DD')
				let checkToken = this.$db.ls.get(`${ this.token }-check`)
				return !this.userData.is_membership && checkToken === time
			},
			// 按钮的显示文案
			checkText: {
				get () {
					return this.notMemberAgainCheck ? '查看建议' : this.text
				},
				set (val) {
					this.text = val
				}
			},
			// 分数对应的description
			scoreDesc () {
				for (let i = 0; i < scoreDescription.length; i++) {
					if (this.score >= scoreDescription[i].minScore && this.score <= scoreDescription[i].maxScore) {
						return scoreDescription[i].description
					}
				}
			},
      isShowNPSModuleNum(){
			  try{
          let num = 0
          num = num + (this.cv.submodule_info.custom_sections_ids.length > 0 ? 1 : 0)
          num = num + (this.cv.submodule_info.edus_ids.length > 0 ? 1 : 0)
          num = num + (this.cv.submodule_info.opus_ids.length > 0 ? 1 : 0)
          num = num + (this.cv.submodule_info.orgs_ids.length > 0 ? 1 : 0)
          num = num + (this.cv.submodule_info.works_ids.length > 0 ? 1 : 0)
          return num >= 3
        }catch (e) {
          return false
        }
      },
      // 是否是会员
			isMembership(){
				return this.userData?.is_membership
			},
		},
		methods: {
			...mapActions('cv', [ 'getCvDetail', 'cvCheck', 'updateProfileData', 'createProfileData', 'updateFirstCvInfo', 'updateVipProfileData' ]),
			...mapMutations('cv', [ 'changeModuleInfo', 'changeRefreshEditor', 'setNpsFlag']),
      // 底部操作栏按钮点击事件处理
      editorBottomClick(key) {
        if(key == 'guanli') {
          this.toModuleManage()
        } else if(key == 'fudao') {
          this.$fn.switch(`/pages/service/index`, () => {
            window.location.href = process.env.VUE_APP_HOST + '/service'
          })
        } else if(key == 'gengduo') {
          this.moreState = true
        } else if(key == 'yulan') {
          this.toPreview()
        }
      },
      // 设置隐私设置
      async changePrivacy() {
			  this.privacy.contact_directly = true
        try {
          let res = await this.$api.user.setPersonPrivacy(this.cvAccountToken, this.privacy)
          if (res.code === 1000) {
            this.privacy = res.data
            this.showToast('打开成功')
            this.cvOnlineFlag = false
          } else {
            this.showToast(res.message)
          }
        } catch (e) {
          console.error(e)
        }
      },
      // 获取个人隐私设置
      async getPersonPrivacy() {
        try {
          let res = await this.$api.user.getPersonPrivacy(this.cvAccountToken)
          if (res.code === 1000) {
            this.privacy = res.data
          } else{
            this.showToast(res.message, 1500)
          }
        } catch (e) {
          console.error(e)
        }
      },
      // 关闭在线简历设置弹窗
      closeCvOnline() {
			  this.cvOnlineFlag = false
      },
      // 关闭nps
      showNps () {
        this.setNpsFlag(false)
      },
			initScrollPoint() {
				this.$nextTick(() => {
					window.scrollTo(0, 0)
				})
			},
			toCvComment() {
				if (this.isWxMini) {
					this.$wechat.miniProgram.navigateTo({
						url: `/pages/cvShare/cvShare?url=${ process.env.VUE_APP_HOST }/cvs/${ this.encodedToken }/share&title=${ this.cv.basic_info.cv_name }`
					})
				} else {
					this.$router.push(`/cvs/${ this.encodedToken }/share`)
				}
				this.$db.ls.set('shareByPreview', true)
			},
			// 上传头像成功后的回调
			changeAvatar (url) {
				this.profiles.avatar_url = url
				this.uploadShowAvatar = false
			},
			// 添加校徽成功
			addSchoolLogo () {
				this.uploadShowLogo = false
			},
			// 点击头像
			addAvatar () {
				// if (!this.profiles.id) {
				// 	this.showToast('请先完善基本信息')
				// 	return
				// }
				if (this.profiles.avatar_url) {
					this.avatarState = true
				} else {
					this.uploadShowAvatar = true
				}
			},
			// 上传头像的弹出框
			changeUpload (type) {
				if (type === 'logo') {
					this.uploadShowLogo = true
				} else {
          // 非会员
          // if(!this.isMembership){
          //   this.showToast('该功能为会员专享', 1500)
          //   this.$router.push(`/buy/member/order`)
          // }else{
          //
          // }
          this.avatarState = false
          this.uploadShowAvatar = true
				}
			},
			// 删除校徽和头像
			deleteConfirm (type) {
				let { token } = this.cv.basic_info
				if (type === 'logo') {
					this.dialog = this.$createDialog({
						title: '提示',
						type: 'confirm',
						content: '确定删除校徽?',
						onConfirm: async () => {
							let res = await this.$api.cv.deleteSchoolLogo(this.token)
							if (res.code === 1000) {
								this.cv.basic_info.school_logo_url = null
							}
						}
					}).show()
				} else {
					this.avatarState = false
					this.dialog = this.$createDialog({
						title: '提示',
						type: 'confirm',
						content: '确定删除照片?',
						onConfirm: async () => {
							// await this.updateProfileData({ token, payload: { avatar_url: '' } })
              await this.updateVipProfileData({ token, payload: { avatar_url: '' }, profile: this.profiles })
							this.profiles.avatar_url = ''
						}
					}).show()
				}
			},
			handleClose () {
				this.uploadShowAvatar = false
				this.uploadShowLogo = false
				this.avatarState = false
			},
			onScroll (pos) {
				let { y } = pos
				if (y < 0) {
					this.barState = this.top <= y
					this.top = y
				}
			},
			// 滚动到底部事件
			scrollEnd () {
				this.barState = true
			},
			// 获取简历的分数和优化建议
			getCvScore () {
				// if (this.notMemberAgainCheck) {
				// 	this.limitCheck({ cv_token: this.token })
				// } else {
				// 	this.cvCheck({ cv_token: this.token, check_limit: 'false' })
				// }
			},
      // 同步在线简历的提示
      syncCvNotify() {
			  this.$createDialog({
          title: '简历推荐提示',
          type: 'confirm',
          content: '大厂已入驻超级简历，简历会被优先推荐<br />你可以在隐私设置中屏蔽不感兴趣公司',
          confirmBtn: {
            text: '关闭推荐',
          },
          cancelBtn: {
            text: '取消',
          },
          onConfirm: () => {
            this.$router.push('/account/privacy')
          }
        }).show()
      },
			// 分数不为零且没有profile id 没有的情况创建 profile 模块
			async _createProfile () {
				if (this.notProfile) {
					let payload = {
						username: this.profiles.username,
						phone: this.profiles.phone,
						email: this.profiles.email,
						cv_token: this.$route.params.token
					}
					let res = await this.$api.cv.createProfiles(payload)
					if (res.status === 1) {
						if (this.userData.is_membership || !this.notMemberAgainCheck) {
							await this.cvCheck({
								cv_token: this.token,
								check_limit: 'false'
							})
							this.loadingShow = false
						}
					}
				}
			},
			// 修改简历名称之后刷新
			refresh (name) {
				this.cv.basic_info.cv_name = name
			},
			// navbar 左侧点击按钮
			leftBtnClick () {
				let show = this.$db.ls.get(`${ this.cvAccountToken }-match`)
				if (this.score < 60 && !show) {
					this.matchShow = true
					this.$db.ls.set(`${ this.cvAccountToken }-match`, true)
				} else {
					this.routeReplace('/cvs')
				}
			},
			// navbar 右侧点击按钮
			toPreview () {
				this.routeTo(`/cvs/${ this.token }/preview`)
			},
			// 修改简历名称的弹窗
			changeCv () {
				this.settingShow = true
			},
			// 非会员每日检查次数判断
			async checkCount () {
				let time = moment().format('YYYY-MM-DD')
				let checkToken = this.$db.ls.get(`${ this.token }-check`)
				if (!this.userData.is_membership && checkToken !== time) {
          await this.getCvCheck({ clickCheck: true })
          this.$db.ls.set(`${ this.token }-check`, time)
          this.$db.ls.set(`${ this.token }-suggestion`, this.suggestions)
          this.$db.ls.set(`${ this.token }-suggestion-time`, this.suggestTime)
          this.checkText = '查看建议'
          this.suggestState = true
					// this.$createDialog({
					// 	type: 'confirm',
					// 	title: '智能检查',
					// 	content: `每天有<span class="high-light-theme"> 1 次</span>免费检查机会<br>是否检查并查看优化建议？`,
					// 	onConfirm: async () => {
					// 	  await this.getCvCheck({ clickCheck: true })
					// 		this.$db.ls.set(`${ this.token }-check`, time)
					// 		this.$db.ls.set(`${ this.token }-suggestion`, this.suggestions)
					// 		this.$db.ls.set(`${ this.token }-suggestion-time`, this.suggestTime)
					// 		this.checkText = '查看建议'
					// 		this.suggestState = true
					// 	}
					// }).show()
				}
        // else if (this.onlineState && this.score >= 60) {
				// 	this.createOnlineCvDialog()
				// }
        else {
				  await this.getCvCheck({ clickCheck: true })
					this.suggestState = true
				}
			},
			// 点击tabbar上面的内容
			async editorBarClick (item) {
				switch (item.type) {
					case 'suggest':
						this.checkCount()
						break
					case 'mentor':
            this.$fn.switch(`/pagas/service/index`, () => {
						  window.location.href = `/service`
            })
						break
					case 'more':
						this.moreState = true
						break
				}
			},
			// 获取当前简历的点评数据
			async initCommentData() {
				try {
					let { token } = this.$route.params
					let payload = {
						page: 1,
						size: 1
					}
					let res = await this.$api.cvComment.getCommentData(token, payload)
					if (res.code === 1000) {
						this.commentTotal = res.data.total_count
					}
				} catch (error) {
					console.log(error)
				}
			},
			// 获取简历的信息
			async _getCvDetail () {
				await this.getCvDetail({ token: this.token })

        let initEditor = this.$route.query.initEditor
        if (initEditor) {
          this.$router.push({ path: '/cvs/89DfMkk/works/add/edit', query: { initEditor: initEditor} })
          return
        }

				if (this.cv.basic_info.kind === 'template' && (this.softDeleteCount || this.userData.cv_count) && !this.experienceEnter) {
					this.$router.push(`/cvs/${ this.token }/experience`)
				}
        this.updateFirstCvInfo(this.cvAccountToken)
				await this._getModuleInfoByApi()
				if (this.cv.basic_info.kind !== 'template' && this.cv.basic_info.kind !== 'sample') this.getCvCheck({})
				this.$db.ls.remove('suggest')
				this.$db.ls.remove('errorInfo')
				this.$db.ls.remove('req')
				this.loadingShow = false
				// if (!this.notProfile) this.loadingShow = false
				this.$forceUpdate()
			},
			// 获取简历的check信息
			async getCvCheck ({ clickCheck }) {
				let custom_sections = []
				let { submodule_info: { sections_position }, basic_info: { token } } = this.cv
				sections_position.forEach(item => {
					if (item.id) {
						let module = {
							id: item.id,
							infos: this.$store.state.cv[item.id] || this.$store.state.cv[item.type] || [],
							section: item.type
						}
						custom_sections.push(module)
					}
				})
        let payload = {
          cv_token: this.cv.basic_info.token,
          cv: {
            ...this.cv,
            profile: this.$store.state.cv.profiles,
            edus: this.$store.state.cv.edus,
            orgs: this.$store.state.cv.orgs,
            works: this.$store.state.cv.works,
            others: this.$store.state.cv.extra,
            opus: this.$store.state.cv.opus,
            custom_sections
          }
        }
        if (clickCheck) payload.manual = 1
				await this.cvCheck(payload)
        // if (this.syncSuccess) this.syncCvNotify()
        if (this.syncSuccess) {
          this.getPersonPrivacy()
          // this.cvOnlineFlag = true
        }
			},
			// 跳转至模块管理页面
			toModuleManage () {
				this.$router.push(`/cvs/${ this.token }/module`)
			}
		}
	}
</script>
<style scoped lang="scss">
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  .cv-show-wrapper {
    height: calc(var(--vh, 1vh) * 100);
    padding-top: 134px;
    .cv-show {
      // background-color: #f9f9f9;
      .top-tool-tip {
        position: fixed;
        top: 44px;
        width: 100vw;
        height: 38px;
        background-color: #F5F8FF;
        padding: 0 24px;
        z-index: 9;
        .tool-tip-image {
          margin-right: 8px;
        }
        i {
          font-weight: bold;
          margin-right: 6px;
          font-size: 20px;
        }
        .to-pc {
          text-decoration: underline;
        }
        span, i {
          color: #4183FF;
        }
      }
      .rate-header {
        position: fixed;
        top: 82px;
        height: 52px;
        background-color: $color-light;
        padding: 12px 24px;
        width: 100vw;
        z-index: 9;
        .rate {
          color: $color-title;
          font-weight: 500;
        }
        .header-btn {
          width: 88px;
          height: 28px;
          border-radius: 14px;
        }
        .has-click {
          color: $color-light;
          background-color: $color-theme;
          border-color: transparent;
        }
      }
      .rate-header-hide-tool-tip {
        top: 44px;
      }
      .scroll-container {
        height: calc(calc(var(--vh, 1vh) * 100) - 134px);
      }
      .rate-container {
        padding: 16px 24px;
        background-color: $color-light;
        border-radius: 3px;
        position: relative;
        margin-bottom: 6px;
        .progress {
          margin-bottom: 10px;
        }
        .info {
          font-size: $font-size-medium;
          line-height: 20px;
          color: $color-title;
          /deep/ * {
            line-height: 20px;
            color: $color-title;
          }
        }
      }
      .cv-infos {
        /deep/ .person-info {
          .title {
            margin-bottom: 30px;
          }
        }
      }
    }
    .hide-bar {
      transform: translateY(100%);
      box-shadow: none;
    }
    .avatar-content {
      background-color: $color-light;
      border-radius: 16px 16px 0 0;
      width: 100vw;
      padding-top: 10px;
      .operation {
        padding: 0 28px;
        .operation-item {
          padding: 18px 0;
          text-align: center;
          color: $color-dark-gray;
          &:first-child {
            border-bottom: 1px solid #f4f4f4;
          }
          .iconfont {
            font-size: 14px;
            margin-right: 14px;
          }
          .iconshanchujianli {
            font-size: 16px;
          }
        }
      }
      .avatar-bottom {
        height: 64px;
        color: $color-title;
        font-size: $font-size-medium-x;
        border-top: 1px solid #dfdfdf;
      }
    }
    .module-manage {
      // width: 100%;
      height: 46px;
      border-radius: 2px;
      background-color: #f4f4f4;
      color: $color-dark-gray;
      margin: 16px 24px 42px;
      font-size: $font-size-medium-x;
    }
		.comment-total-container {
			i {
				margin-right: 6px;
			}
			position: fixed;
			z-index: 19;
			right: 20px;
			border-radius: 20px;
			background-color: $color-light;
			@include fixed-bottom(26px);
			padding: 12px;
			box-shadow: 0 2px 10px 0 rgba($color: #000000, $alpha: .08);
			border: 1px solid #ECECEC;
			color: $color-title;
		}
    .cv-online-popup {
      width: 311px;
      //height: 256px;
      border-radius: 4px;
      background-color: #fff;
      box-sizing: border-box;
      padding: 30px 24px 24px;
      .title-container {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .title {
          font-size: 18px;
          color: #404040;
          font-weight: 500;
        }
        .iconfont {
          color: #8c8c8c;
          font-size: 20px;
        }
      }
      .content-container {
        width: 100%;
        margin-top: 16px;
        .item {
          display: flex;
          .point {
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background-color: #404040;
            margin-right: 12px;
            margin-top: 11px;
          }
          .text {
            max-width: 245px;
            line-height: 28px;
            font-size: 14px;
            color: #606060;
          }
        }
        .active {
          .point {
            background-color: #ff6644;
          }
          .text {
            color: #ff6644;
          }
        }
      }
      .btn-container {
        width: 100%;
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .btn {
          width: 121px;
          height: 36px;
          border-radius: 2px;
          border: 1px solid #ff6644;
          text-align: center;
          line-height: 36px;
          font-size: 14px;
        }
        .cancel-btn {
          color: #ff6644;
        }
        .confirm-btn {
          background-color: #ff6644;
          color: #fff;
        }
      }
    }
  }
  .cv-show-wrapper-hide-tool-tip {
    padding-top: 96px;
  }
  .zero-show {
    padding-top: 82px;
  }
  .zero-show-hide-tool-tip {
    padding-top: 44px;
  }
</style>
